<template>
    <aside class="sidebar"
        :class="[{ 'is-fold': is_fold }, { 'is-opening': is_opening }, { 'is-folding': is_folding }, { 'is-motom-internal-user': store.state.user_data.is_motom_internal_user }]">
        <a href="/" class="pages-logo" v-if="is_empty && $route.name === 'pages'">
            <svg-icon name="logo" />
        </a>
        <Scrollbar v-if="!is_empty" class="inner">
            <Loading class="static" v-if="!store.state.user_data" style="margin-top: 120px;" />
            <EmptyHeader
                v-if="(store.state.user_data && store.state.user_data.merchant_accounts.length < 1) || $route.name == 'landing' || store.state.user_data.merchant_account === null"
                :is_fold="is_fold" />
            <div class="header-box" v-else>
                <header class="header user"
                    v-if="store.state.user_data && store.state.user_data.merchant_accounts.length === 1">
                    <figure class="avatar" v-tippy="{ content: is_fold ? brand_name : '', placement: 'right' }">
                        <img :src="store.state.user_data.merchant_account.brand_logo" />
                    </figure>
                    <h2 v-if="!is_fold">{{ store.state.user_data.merchant_account.merchant_display_name }}</h2>
                </header>

                <header class="header users" v-else-if="store.state.user_data"
                    :class="{ 'active': is_open_merchant_menu }"
                    @click.stop="is_open_merchant_menu = !is_open_merchant_menu; is_open_sub_menu = false;">
                    <figure class="avatar" v-tippy="{ content: is_fold ? brand_name : '', placement: 'right' }">
                        <img :src="store.state.user_data.merchant_account.brand_logo" />
                    </figure>
                    <h2 v-if="!is_fold">{{ store.state.user_data.merchant_account.merchant_display_name }}</h2>
                    <svg-icon name="next" />
                </header>

                <nav class="merchant-menu" v-if="store.state.user_data" :class="{ 'open': is_open_merchant_menu }">
                    <Scrollbar>
                        <ul>
                            <li v-for="(item, key) in store.state.user_data.merchant_accounts" :key="key"
                                @click="selectMerchant(item)">
                                <figure class="avatar">
                                    <img :src="item.brand_logo" />
                                </figure>
                                {{ item.merchant_display_name }}
                            </li>
                        </ul>
                    </Scrollbar>
                </nav>

                <nav class="menus" v-if="store.state.user_data">
                    <ul>
                        <!-- when the user role is analyst,and no any merchant creators,can not see this page. -->
                        <li>
                            <router-link :to="store.state.user_data.creator_url"
                                :class="{ 'router-link-active router-link-exact-active': $route.name.split('--')[0] === 'creator' }"
                                v-tippy="{ content: is_fold ? 'Creator Management' : '', placement: 'right' }">
                                <svg-icon name="users" />
                                <span v-if="!is_fold">Creator Management</span>
                            </router-link>
                        </li>

                        <li v-for="(item, key) in top_menus" :key="key" v-show="item.show" :class="[
                            'menu-item-' + item.meta,
                            ((item.meta === 'storefront' && $route.name === 'storefront') ||
                                (item.meta === 'storefront' && store.state.spec_value.storefrontOpen)) &&
                            'menu-item-storefront-open',
                        ]">
                            <div class="menu-div-box">
                                <!-- ✅ Storefront Curation 用 el-popover -->
                                <el-popover v-if="item.text === 'Storefront Curation' && is_fold"
                                    placement="right-start" trigger="click" popper-class="storefront-popover"
                                    width="220">
                                    <!-- ✅ popover 內容 -->
                                    <template #default>
                                        <div class="big-sub-menu" v-if="item.sub_menus && item.sub_menus.length > 0">
                                            <ul>
                                                <li v-for="sub_menu in item.sub_menus" :key="sub_menu.name">
                                                    <router-link :to="sub_menu.path" :class="{
                                                        'router-link-active': $route.params?.id === sub_menu.id,
                                                    }">
                                                        <h2>{{ sub_menu.name }}</h2>
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </div>
                                    </template>

                                    <!-- ✅ 觸發區塊 -->
                                    <template #reference>
                                        <div class="router-link-box storefront-trigger">
                                            <svg-icon :name="item.icon" />
                                            <span class="nav-text" v-if="!is_fold" v-html="item.text"></span>
                                            <i v-if="!is_fold && item.sub_menus?.length > 0">
                                                <svg-icon name="menu-arrow" />
                                            </i>
                                        </div>
                                    </template>
                                </el-popover>

                                <!-- ❗️其他 menu 正常顯示 -->
                                <component v-else @click="handleRouterClick(item, key)" :ref="item.meta + 'Ref'"
                                    :is="item.text === 'Storefront Curation' ? 'div' : 'router-link'" :to="item.to"
                                    class="router-link-box" :class="{
                                        'router-link-active router-link-exact-active':
                                            ($route.name.split('--')[0] === item.meta ||
                                                $route.meta.menu_meta === item.meta) &&
                                            item.text !== 'Storefront Curation',
                                    }" v-tippy="{ content: is_fold ? item.tooltip_text : '', placement: 'right' }">
                                    <svg-icon :name="item.icon" />
                                    <span class="nav-text" v-if="!is_fold" v-html="item.text"></span>
                                </component>
                                <i class="sub-menu-tigger"
                                    v-if="!is_fold && item.sub_menus && item.sub_menus.length > 0"><svg-icon
                                        name="menu-arrow" /></i>
                            </div>
                            <div v-show="!is_fold && item.is_active" :key="item.is_active">
                                <div class="big-sub-menu" v-if="item.sub_menus && item.sub_menus?.length > 0">
                                    <ul>
                                        <li v-for="sub_menu in item.sub_menus" :key="sub_menu.name">
                                            <router-link :to="sub_menu.path"
                                                :class="{ 'router-link-active': $route.params?.id === sub_menu.id }"
                                                v-tippy="{ content: sub_menu.name, placement: 'right' }">
                                                <h2 v-if="!is_fold">{{ sub_menu.name }}</h2>
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                </nav>
            </div>

            <footer v-if="store.state.user_data">
                <!-- <Usage :is_mini="false" /> -->
                <nav class="menu">
                    <ul>
                        <li v-for="(item, key) in footer_data.menus" :key="key" :class="['menu-' + item.icon]">
                            <router-link :to="item.to"
                                v-tippy="{ content: is_fold ? item.tooltip_text : '', placement: 'right' }">
                                <svg-icon :name="item.icon" />
                                <span v-if="!is_fold" v-html="item.text"></span>
                            </router-link>
                        </li>
                        <li>
                            <a v-if="store.state.projectName !== 'cj'"
                                v-tippy="{ content: is_fold ? 'Contact Support' : '', placement: 'right' }"
                                :href="`mailto:${store.state.mail_to}?subject=${store.state.user_data.merchant_account ? store.state.user_data.merchant_account.merchant_display_name + ' - ' : ''}Support Request&body=Please%20describe%20your%20issue%20below%20in%20as%20much%20detail%20as%20possible%20(including%20what%20device%20you're%20using%20and%20screenshots,%20if%20necessary).%20A%20support%20team%20member%20will%20contact%20you%20within%201-2%20business%20days.`"
                                target="_blank"><svg-icon name="help" /><span v-if="!is_fold">Contact Support</span></a>
                            <a v-else
                                v-tippy="{ content: is_fold ? 'Contact Support' : '', placement: 'right' }"
                                @click.prevent="eventBus.emit('open-global-drawer', 'help-support')"
                                href="#"><svg-icon name="help" /><span v-if="!is_fold">Contact Support</span></a>
                        </li>
                    </ul>
                </nav>

                <el-popover placement="right-start" trigger="click" width="180" popper-class="user-menu-popover"
                    @show="is_open_sub_menu = true" @hide="is_open_sub_menu = false">
                    <!-- ✅ popover 內容 -->
                    <template #default>
                        <nav class="sub-menu">
                            <ul>
                                <li v-for="(item, key) in footer_data.user.menus" :key="key"  @click="handleUserMenuClick(item)" v-show="item.show">
                                    <router-link :to="item.to">
                                        <span v-html="item.text"></span>
                                    </router-link>
                                </li>
                                <li>
                                    <span @click="Logout">Log Out</span>
                                </li>
                            </ul>
                        </nav>
                    </template>

                    <!-- ✅ 觸發區塊 -->
                    <template #reference>
                        <div class="user-info" v-tippy="{ content: is_fold ? 'Your profile' : '', placement: 'right' }">
                            <figure class="avatar">
                                <img v-if="store.state.user_data.avatar" :src="store.state.user_data.avatar" />
                                <img v-else :src="require('@/assets/images/user.png')" />
                            </figure>
                            <h2 v-if="!is_fold"
                                v-html="store.state.user_data.first_name + ' ' + store.state.user_data.last_name"></h2>
                            <svg-icon name="arrow-down" v-if="!is_fold" />
                        </div>
                    </template>
                </el-popover>

                <div class="bottom-box">
                    <div class="copyright" v-if="!is_fold">
                        <p class="pick" @click="openProtalTerms">Motom’s Terms of Use</p>
                        <p class="pick" @click="openPrivacy">Motom’s Privacy Policy</p>
                        Powered by Anchor<br>
                        <p class="overflow-p">All rights reserved by Motom {{ new Date().getFullYear() }}</p>
                    </div>
                    <div class="arrow-btn" @click="foldMenu"
                        v-tippy="{ content: is_fold ? 'Click to expend menu' : 'Click to collapse menu', placement: 'right' }">
                        <svg-icon name="arrow-2" />
                    </div>
                </div>
            </footer>
        </Scrollbar>
    </aside>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Loading from '@/components/ui/Loading.vue';
import EmptyHeader from '@/components/SidebarHeader.vue';
import { ElPopover } from 'element-plus';

// ===== props =====
defineProps({
    is_empty: {
        type: Boolean,
        default: false,
    },
})

// ===== vuex, router, route =====
const store = useStore()
const route = useRoute()
const router = useRouter()
const app = getCurrentInstance()
const ajax = app.appContext.config.globalProperties.$ajax;
const eventBus = app.appContext.config.globalProperties.EventBus;
const { $ProjectName } = app.appContext.config.globalProperties;
// ===== state =====
const is_open_merchant_menu = ref(false)
const is_open_sub_menu = ref(false)

const getInitialFoldState = () => {
    switch (route.name) {
        case 'reset-password':
        case 'login':
        case 'onboard':
        case 'pages':
            return false
        default:
            return window.localStorage.getItem('side_bar_fold') === null ||
                window.localStorage.getItem('side_bar_fold') === 'true'
    }
}
const is_fold = ref(getInitialFoldState())
const is_opening = ref(false)
const is_folding = ref(false)

const footer_data = ref({
    user: {
        menus: [
            {
                text: 'Profile',
                to: '/settings/account',
                show: true,
            },
            {
                text: $ProjectName === 'cj' ? 'Creator Academy' : 'Creator HQ',
                to: $ProjectName === 'cj' ? '/creator-academy' : '/creator-hq',
                show: $ProjectName === 'cj' && (store.state.user_data?.permission_list?.role_type >= 80 || store.state.user_data?.is_motom_internal_user ),
            },
            {
                text: 'Dashboard',
                to: '/landing',
                show: store.state.user_data.is_motom_internal_user && $ProjectName ==='motom' ,
            },
        ],
    },
    menus: [
        {
            text: 'Settings',
            tooltip_text: 'Settings',
            to: '/settings/account',
            icon: 'setting',
        },
    ],
})


// ===== computed =====
const permission_analytics = computed(() => store.state.user_data?.permission_list?.analytics)
const permission_recruitment = computed(() => store.state.user_data?.permission_list?.recruitment)
const permission_reports = computed(() => store.state.user_data?.permission_list?.reports)
const permission_mes = computed(() => store.state.user_data?.permission_list?.messagesAndAnnouncements)
const merchant_accounts = computed(() => store.state.user_data?.merchant_account || {})
const top_menus = computed(() => [
    {
        text: 'Analytics',
        tooltip_text: 'Storefront analytics',
        to: '/analytics/overview',
        icon: 'analytics',
        meta: 'analytics',
        show: permission_analytics.value?.viewPerformanceSummaries?.permission !== 0,
    },
    {
        text: 'Recruitment',
        tooltip_text: 'Recruitment',
        to: '/programs/applications-list',
        icon: 'programs',
        meta: 'programs',
        show: permission_recruitment.value?.manageApplications?.permission !== 0,
    },
    {
        text: 'Messaging',
        tooltip_text: 'Messaging',
        to: $ProjectName === 'cj' ? '/messaging/announcements' : '/messaging/chats',
        icon: 'comment',
        meta: 'messaging',
        show: !(
            permission_mes.value?.manageMessaging?.permission === 0 &&
            permission_mes.value?.manageAnnouncements?.permission === 0
        ),
    },
    {
        text: 'Storefront Curation',
        tooltip_text: 'Storefront Curation',
        to: '/null',
        icon: 'storefront2',
        meta: 'storefront',
        sub_menus: [
            { name: 'Products', path: '/storefront/products', id: 'products', p: 'P', svg: 'sales' },
            { name: 'Collections', path: '/storefront/collections', id: 'collections', p: 'C', svg: 'likes' }
        ],
        is_active: store.state.spec_value.storefrontOpen,
        show: merchant_accounts.value?.is_enable_storefront_curation && store.state.user_data.is_motom_internal_user

    },
    {
        text: 'Reports',
        tooltip_text: 'Reports',
        to: '/reports-list',
        icon: 'download',
        meta: 'reports',
        show: permission_reports.value?.downloadReports?.permission !== 0,
    },
])

// ===== methods =====
const openPrivacy = () => {
    eventBus.emit('open-global-drawer', 'privacy-policy')
}

const openProtalTerms = () => {
    eventBus.emit('open-global-drawer', 'terms-of-use')
}

const Logout = () => {
    router.replace('/logout')
}

const stringToSlug = (text) => {
    return text.toLowerCase().replace(/ /g, '-')
}

const foldMenu = () => {
    window.localStorage.setItem('side_bar_fold', !is_fold.value)

    if (is_fold.value) {
        is_opening.value = true
        is_folding.value = false
        is_fold.value = false
    } else {
        is_opening.value = false
        is_folding.value = true
        setTimeout(() => {
            is_fold.value = true
        }, 500)
    }
}

const selectMerchant = (item) => {
    is_open_merchant_menu.value = false
    ajax(`/select-current-merchant-account`, {
        method: 'post',
        data: {
            merchant_account_id: item.id,
        },
    }).then(() => {
        store.state.user_data.merchant_account = item
        if (item.enable_creators_count === 0) {
            if (store.state.user_data < 3) {
                window.location.replace('/creator/get-started')
            } else {
                window.location.replace('/analytics/overview')
            }
        } else {
            window.location.replace('/creator/list')
        }
    })
}

const handleClick = (e) => {
    if (!is_open_merchant_menu.value && !is_open_sub_menu.value) return
    const root_parent = document.body
    const class_names = ['merchant-menu', 'user-data']
    let is_select_el = false

    if (class_names.some((class_name) => e.target.classList.contains(class_name))) {
        is_select_el = true
    } else {
        let p = e.target.parentNode
        while (p !== root_parent) {
            const o = p
            if (o.parentNode) p = o.parentNode
            else return

            if (class_names.some((class_name) => o.classList.contains(class_name))) {
                is_select_el = true
            }
        }
    }

    if (!is_select_el) {
        is_open_sub_menu.value = false
        is_open_merchant_menu.value = false
    }
}

// ===== lifecycle =====
onMounted(() => {
    window.addEventListener('click', handleClick)
})

//9338
const handleRouterClick = (item, key) => {
    if (item.text === 'Storefront Curation') {
        store.state.spec_value.storefrontOpen = !store.state.spec_value.storefrontOpen;
    }
};

const handleUserMenuClick = (item) => {
  if (item.to) {
    router.push(item.to)
  }
}

onBeforeUnmount(() => {
    window.removeEventListener('click', handleClick)
})
</script>

<style lang="scss">
.sidebar {
    // max-width: 360px;
    // min-width: 320px;
    // width: 25%;
    width: 260px;
    min-width: 260px;
    background-color: var(--dark-blue);
    color: white;

    .pages-logo {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 74%;
        margin: -16px auto 0;
        color: white;
        overflow: hidden;
        transition: opacity .3s ease;

        &:hover {
            color: white;
        }

        svg {
            width: 192px;
            min-width: 192px;
            height: auto;
        }
    }

    &>.scrollbar-content {
        height: 100%;
        overflow: auto;
        display: grid;
        grid-template-rows: 1fr auto;
        grid-template-columns: 100%;
    }


    &.is-opening {
        // min-width: 320px;
        // width: 25%;
        // width: 320px;
        transition: min-width .5s ease-in-out, width .5s ease-in-out;
    }

    &.is-folding {
        min-width: 83px;
        width: 83px;
        transition: min-width .5s ease-in-out, width .5s ease-in-out;

        .pages-logo {
            opacity: 0;
        }
    }

    &.is-fold {
        min-width: 83px;
        width: 83px;
        // transition: min-width .75s ease-in-out, width .75s ease-in-out;

        .pages-logo {
            opacity: 0;
            pointer-events: none;
        }

        .header-box {
            header {
                margin: 23px 16px 16px;
                height: 74px;
                display: flex;
                align-items: center;
                justify-content: center;

                &.users {
                    padding: unset;
                    border: unset;
                    border-radius: unset;
                    background: unset;
                    cursor: unset;

                    svg {
                        display: none;
                    }
                }

                .avatar {
                    height: 48px;
                    width: 48px;
                    min-width: 48px;
                    min-height: 48px;
                }
            }
        }

        footer .menu a svg.svg-icon--help {
            left: -1px;
        }

        .menus {
            display: flex;
            justify-content: center;


            .badge {
                top: 6px;
                right: -6px;
            }

            a,
            .router-link-box {
                padding: unset;
                width: 48px;
                height: 48px;
                justify-content: center;
                border-radius: 100px;

                svg {
                    margin-right: unset;
                }
            }
        }

        footer {
            .menu {
                display: flex;
                justify-content: center;

                a {
                    padding: unset;
                    width: 40px;
                    height: 40px;
                    justify-content: center;
                    border-radius: 100px;

                    svg {
                        margin-right: unset;
                    }
                }
            }

            .user-info {
                margin: 16px 16px 24px;
                display: flex;
                justify-content: center;
            }

            .sub-menu {
                left: 70px;
            }

            .bottom-box {
                margin: 16px 16px 32px;
                display: flex;
                justify-content: center;

                .arrow-btn>svg {
                    transform: unset;
                }
            }
        }

        .merchant-menu {
            left: 10px;
            transform: translate(0%, -15%);
            top: 100px;
            position: fixed;

            &::after {
                left: 24px;
            }

            &.open {
                transform: translate(0%, 0);
            }
        }
    }

    .header {
        height: 72px;
        margin: 24px 16px;
        display: flex;
        align-items: center;

        &.users {
            padding: 12px;
            border: 1px solid transparent;
            border-radius: 36px;
            cursor: pointer;
            transition: all .2s ease;

            .avatar {
                height: 48px;
                width: 48px;
                min-width: 48px;
            }

            h2 {
                font-size: 20px;
            }

            svg {
                height: 12px;
                width: 12px;
                transform: rotate(90deg);
            }

            &.active,
            &:hover {
                background-color: var(--neureal);
                border: 1px solid var(--black-75);
            }
        }

        .avatar {
            height: 62px;
            width: 62px;
            background-color: var(--white);
            overflow: hidden;
            border-radius: 50%;
            border: solid 1px var(--black-20);

            img {
                height: 100%;
                width: 100%;
                display: block;
                object-fit: contain;
            }
        }

        h2 {
            flex: 1;
            padding-left: 16px;
            letter-spacing: 1px;
            display: block;
            font: var(--font-demi-24);
            font-size: 30px;
            line-height: 1.1;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
        }
    }

    .header-box {
        position: relative;
    }

    .merchant-menu {
        min-width: 200px;
        max-width: calc(100% - 40px);
        top: 110px;
        left: 50%;
        position: absolute;
        background: white;
        transition: all .3s ease-in-out;
        transform: translate(-50%, -15%);
        opacity: 0;
        pointer-events: none;
        border-radius: 6px;
        z-index: 100;

        .scrollbar-content {
            height: 100%;
            max-height: 60vh;
        }

        &:after {
            left: 50%;
            transform: translate(-50%, 0);
            border: solid transparent;
            content: "";
            height: 0;
            width: 0;
            position: absolute;
            border-color: rgba(0, 0, 0, 0);
            border-right-color: #fff;
            border-width: 6px;
            top: -12px;
            transform: rotate(90deg);
        }

        &.open {
            transform: translate(-50%, 0);
            opacity: 1;
            pointer-events: unset;
        }

        ul {

            li {
                padding: 8px;
                border-radius: 6px;
                display: flex;
                align-items: center;
                font: var(--font-fg-16);
                color: var(--dark-blue);
                cursor: pointer;
                // white-space: nowrap;
                // overflow: hidden;
                // text-overflow: ellipsis;

                .nav-text {
                    flex: 1;
                }

                &:hover {
                    background: var(--black-20);
                    color: var(--black-75);
                }

                .avatar {
                    margin-right: 8px;
                    height: 28px;
                    width: 28px;
                    min-width: 28px;
                    display: block;
                    background-color: var(--white);
                    overflow: hidden;
                    border-radius: 50%;
                    border: solid 1px var(--black-20);

                    img {
                        height: 100%;
                        width: 100%;
                        display: block;
                        object-fit: contain;
                    }
                }
            }
        }
    }

    .router-link-box {
        cursor: pointer;
    }

    .menu,
    .menus {

        li {
            margin: 16px 0;
        }

        a,
        .router-link-box {
            color: var(--black-40);
            display: flex;
            align-items: center;
            height: 40px;
            border-radius: 20px;
            font: var(--font-fg-16);
            padding: 0 18px;
            border: 1px solid transparent;
            position: relative;

            .badge {
                position: absolute;
                top: 50%;
                transform: translate(0%, -50%);
                right: 8px;
                background-color: var(--alert);
                color: white;
                border-radius: 100px;
                padding: 2px 4px;
                font: var(--font-fg-10);
                min-width: 18px;
                text-align: center;
            }

            svg {
                height: 20px;
                width: 20px;
                margin-right: 8px;
                min-width: 20px;
            }

            span {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .svg-icon--analytics,
            .svg-icon--help {
                height: 18px;
                width: 18px;
                position: relative;
                left: 1px;

                &+span {
                    position: relative;
                    left: 2px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

            }

            .svg-icon--setting {
                height: 26px;
                width: 26px;

                &+span {
                    position: relative;
                    left: -3px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

            &:hover {
                color: white;
            }

            &.router-link-active,
            &.router-link-exact-active {
                background: rgba(255, 255, 255, 0.15);
                border: 1px solid rgba(255, 255, 255, 0.05);
                color: white;
            }
        }
    }

    .sub-menu {
        li h2 {
            padding-left: 28px;
        }
    }

    .menu-item-storefront-open {
        background: rgba(255, 255, 255, 0.15);
        border:none;
        padding: 2px 0;
        border-radius: 24px;
        position: relative;
    }

    .big-sub-menu {

        li{
            margin: 0;
        }

        li a {
            border-radius: 0;
        }

        h2 {
            margin-left: 28px;
        }

        svg {
            width: 16px !important;
            height: 16px !important;
        }
    }

    .menu-item-storefront {

        .menu-div-box {
            display: flex;
            align-items: center;
            height: 40px;
            box-sizing: border-box;

            svg {
                width: 20px;
                height: 20px;
                margin-top: 4px;
            }
        }
    }


    footer {
        .ui-usage-large {
            margin: 0 16px;
        }

        .menu {
            padding-bottom: 8px;

            li {
                margin: 0 0 4px;
                // min-width: 250px;
            }
        }

        .user-info {
            margin: 16px 32px 24px;
            display: flex;
            align-items: center;
            cursor: pointer;
            color: var(--black-40);

            .avatar {
                height: 28px;
                width: 28px;
                min-width: 28px;
                background-color: var(--black-20);
                border: 2px solid var(--black-75);
                overflow: hidden;
                border-radius: 50%;

                img {
                    height: 100%;
                    width: 100%;
                    display: block;
                    object-fit: cover;
                }
            }

            h2 {
                padding: 0 8px;
                display: block;
                font: var(--font-fg-16);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            svg {
                height: 14px;
                width: 14px;
                display: block;
            }
        }

        .user-data {
            position: relative;

            // &:hover {

            //     .user-info {
            //         color: white;
            //     }

            //     .sub-menu {
            //         transform: translate(0%, 0);
            //         opacity: 1;
            //         pointer-events: unset;
            //     }
            // }

            &.open {

                .user-info {
                    color: white;
                }

                .sub-menu {
                    transform: translate(0%, 41.5px);
                    opacity: 1;
                    pointer-events: unset;
                }
            }
        }

        .sub-menu {
            position: fixed;
            background-color: white;
            box-shadow: var(--bot-2dp);
            left: 180px;
            z-index: 99;
            border-radius: 8px;
            // margin-left: 100%;
            width: 170px;
            margin-top: -80px;
            padding: 5px 0;
            transition: all .3s ease-in-out;
            transform: translate(25%, 0);
            opacity: 0;
            pointer-events: none;

            &:after {
                right: 100%;
                border: solid transparent;
                content: "";
                height: 0;
                width: 0;
                position: absolute;
                pointer-events: none;
                border-color: rgba(0, 0, 0, 0);
                border-right-color: #fff;
                border-width: 6px;
                bottom: 20px;
            }

            li>span,
            a {
                display: block;
                padding: 8px 12px;
                color: var(--black-90);
                cursor: pointer;
                font: var(--font-fg-14);

                &:hover {
                    background-color: var(--bg-02);
                }
            }
        }

        .bottom-box {
            margin: 16px 32px 32px;
            display: flex;
            align-items: center;

            .copyright {
                font-size: 12px;
                color: var(--black-40);
                flex: 1;

                a {
                    color: var(--black-40);
                }

                .overflow-p {
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                }

                .pick {
                    cursor: pointer;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }

            .arrow-btn {
                width: 32px;
                height: 32px;
                padding: 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                background: rgba(255, 255, 255, 0.1);
                border: 1px solid rgba(255, 255, 255, 0.1);
                border-radius: 100px;
                cursor: pointer;

                svg {
                    width: 9px;
                    height: 9px;
                    fill: var(--black-40);
                    transform: rotate(-180deg);
                }
            }
        }
    }
}

body.page-settings .menu .menu-setting a {
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.05);
    color: white;
}

.storefront-popover,
.user-menu-popover {
    padding: 4px 0 !important;
    width: auto !important;

    li {
        padding: 8px 16px;
        transition: .3s;
        cursor: pointer;

        a {
            color: var(--Black-90);
            text-decoration: none;
        }

        &:hover {
            background-color: var(--bg-02);
        }
    }
}
</style>
